module.exports = __webpack_public_path__ + "img/20m.7d5254b7.png";